import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA008_Request,
  IAPI_STA008_Response,
} from "../../../type/apiType";

// 退職者詳細情報更新
const httpAPI_STA008 = async (
  param: IAPI_STA008_Request
): Promise<IAPI_STA008_Response> => {
  let res = await http.post(ApiUrl.API_STA008, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA008 };
